// extracted by mini-css-extract-plugin
export default {"btn":"CapabilityLevelInfoModal_btn__+3YMj","imageWrapper":"CapabilityLevelInfoModal_imageWrapper__DB7dg","title":"CapabilityLevelInfoModal_title__YjDsz"};